<div class="leaderboard-container">
  <!-- Time Range Selection -->
  <div class="time-range-selector">
    <div class="date-filter-header" (click)="toggleDateOptions()">
      <div class="header-left">
        <span class="filter-label">📅 Time Period:</span>
        <span class="current-period">{{ verbiage }}</span>
      </div>
      <button class="toggle-button" [class.expanded]="isDateOptionsExpanded">
        <span class="toggle-icon" *ngIf="!isDateOptionsExpanded">▼</span>
        <span class="toggle-icon" *ngIf="isDateOptionsExpanded">▲</span>
      </button>
    </div>
    
    <div class="date-chips-container" *ngIf="isDateOptionsExpanded" [@expandCollapse]>
      <button 
        *ngFor="let option of dateOptions" 
        class="date-chip"
        [class.active]="selectedPeriod === option.value"
        (click)="selectDateOption(option.value)">
        <span class="chip-icon">{{ option.icon }}</span>
        <span class="chip-label">{{ option.label }}</span>
      </button>
      
      <button 
        class="date-chip custom-chip"
        [class.active]="selectedPeriod === 'custom'"
        (click)="openCustomDateModal()">
        <span class="chip-icon">📆</span>
        <span class="chip-label">Custom</span>
      </button>
    </div>
  </div>

  <!-- Custom Date Modal -->
  <nz-modal
    [(nzVisible)]="isCustomDateModalVisible"
    nzTitle="Select Custom Date Range"
    (nzOnCancel)="handleCustomDateCancel()"
    (nzOnOk)="handleCustomDateOk()"
    [nzFooter]="modalFooter">
    <ng-container *nzModalContent>
      <div class="custom-date-modal-content">
        <nz-range-picker 
          [(ngModel)]="tempDateRange" 
          [nzFormat]="'MMM d, yyyy'"
          style="width: 100%;">
        </nz-range-picker>
      </div>
    </ng-container>
    <ng-template #modalFooter>
      <button nz-button nzType="default" (click)="handleCustomDateCancel()">Cancel</button>
      <button nz-button nzType="primary" (click)="handleCustomDateOk()">Apply Date Range</button>
    </ng-template>
  </nz-modal>

  <!-- Quick Stats Grid -->
  <div class="stats-grid">
    <div *ngFor="let stat of topStats; let i = index" class="stat-card" [class.loading]="isLoading">
      <div class="stat-icon" [ngClass]="'stat-icon-' + i">
        <span *ngIf="i === 0">📊</span>
        <span *ngIf="i === 1">✅</span>
        <span *ngIf="i === 2">❌</span>
        <span *ngIf="i === 3">⏳</span>
      </div>
      <div class="stat-content">
        <div class="stat-label">{{ stat.title }}</div>
        <div class="stat-value">{{ stat.value }}</div>
        <div class="stat-period">{{ verbiage }}</div>
      </div>
    </div>
  </div>

  <!-- Record Board -->
  <div class="record-board">
    <div class="record-board-header">
      <span class="trophy-icon">🏆</span>
      <h2>RECORD BOARD</h2>
      <span class="trophy-icon">🏆</span>
    </div>
    <div class="record-cards">
      <div class="record-card personal-best">
        <div class="record-card-header">
          <span class="badge-icon">⭐</span>
          <h3>Your Personal Best</h3>
        </div>
        <nz-skeleton [nzLoading]="recordLoading">
          <div class="record-stats">
            <div class="record-stat">
              <div class="record-stat-label">Best Sales</div>
              <div class="record-stat-value">{{ currentUserBestSales }}</div>
              <div class="record-stat-date">{{ currentUserBestSalesDate | date : "MMM d, y" }}</div>
            </div>
            <div class="record-divider"></div>
            <div class="record-stat">
              <div class="record-stat-label">Best Installs</div>
              <div class="record-stat-value">{{ currentUserBestInstalls }}</div>
              <div class="record-stat-date">{{ currentUserBestInstallsDate | date : "MMM d, y" }}</div>
            </div>
          </div>
        </nz-skeleton>
      </div>

      <div class="record-card hall-of-fame">
        <div class="record-card-header">
          <span class="badge-icon">👑</span>
          <h3>Hall of Fame</h3>
        </div>
        <nz-skeleton [nzLoading]="recordLoading">
          <div class="record-stats">
            <div class="record-stat">
              <div class="record-stat-label">All-Time Best Sales</div>
              <div class="record-stat-value">{{ allTimeBestSales }}</div>
              <div class="record-stat-date">{{ allTimeBestSalesDate | date : "MMM d, y" }}</div>
            </div>
            <div class="record-divider"></div>
            <div class="record-stat">
              <div class="record-stat-label">All-Time Best Installs</div>
              <div class="record-stat-value">{{ allTimeBestInstalls }}</div>
              <div class="record-stat-date">{{ allTimeBestInstallsDate | date : "MMM d, y" }}</div>
            </div>
          </div>
        </nz-skeleton>
      </div>
    </div>
  </div>

  <!-- Performance Chart (Desktop Only) -->
  <ng-container *ngIf="!isMobile">
    <div class="chart-container">
      <h3 class="section-title">📈 Performance Metrics</h3>
      <nz-skeleton [nzLoading]="isLoading">
        <canvas baseChart [datasets]="metricsData" [labels]="metricsLabels" [options]="metricsOptions" [legend]="true" [type]="'line'"></canvas>
      </nz-skeleton>
    </div>
  </ng-container>

  <!-- Leaderboard Section -->
  <div class="leaderboard-section">
    <div class="section-header">
      <h3 class="section-title">🏅 Leaderboard Rankings</h3>
      <div class="sort-controls" *ngIf="isMobile">
        <label class="sort-label">Sort by:</label>
        <nz-select [(ngModel)]="leaderboardSortBy" (ngModelChange)="changeLeaderboardSort($event)" class="sort-select">
          <nz-option *ngFor="let option of sortOptions" [nzValue]="option.value" [nzLabel]="option.icon + ' ' + option.label"></nz-option>
        </nz-select>
      </div>
    </div>
    <nz-skeleton [nzLoading]="isLoading">
      <!-- Desktop Table View -->
      <div class="desktop-leaderboard" *ngIf="!isMobile">
        <nz-table
          #virtualTable
          [nzSort]="true"
          [nzData]="leaderboardData"
          [nzVirtualItemSize]="54"
          [nzFrontPagination]="false"
          [nzShowPagination]="false"
          [nzScroll]="{ x: '1000px', y: '400px' }"
        >
          <thead>
            <tr>
              <th [nzWidth]="'80px'">Rank</th>
              <th [nzWidth]="'150px'" [nzSortFn]="sortFns['name']">Player</th>
              <th [nzWidth]="'100px'" [nzSortFn]="sortFns['total_orders']">Sales</th>
              <th [nzWidth]="'100px'" [nzSortFn]="sortFns['total_installs']">Installs</th>
              <th [nzWidth]="'100px'" [nzSortFn]="sortFns['cancels']">Cancels</th>
              <th [nzWidth]="'100px'" [nzSortFn]="sortFns['pending']">Pending</th>
              <th [nzWidth]="'120px'" [nzSortFn]="sortFns['pullThrough']">Completion</th>
              <th [nzWidth]="'100px'" [nzSortFn]="sortFns['multiplier']">Multiplier</th>
              <th [nzWidth]="'100px'" [nzSortFn]="sortFns['score']">Score</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of virtualTable.data; let i = index"
              [ngClass]="{
                'gold-rank': i === 0,
                'silver-rank': i === 1,
                'bronze-rank': i === 2
              }"
            >
              <td>
                <span class="rank-badge" [ngSwitch]="i">
                  <span *ngSwitchCase="0" class="medal gold">🥇</span>
                  <span *ngSwitchCase="1" class="medal silver">🥈</span>
                  <span *ngSwitchCase="2" class="medal bronze">🥉</span>
                  <span *ngSwitchDefault class="rank-number">{{ i + 1 }}</span>
                </span>
              </td>
              <td><strong>{{ user['first_name'] }} {{ user['last_name'] }}</strong></td>
              <td>{{ user?.['total_orders'] || 0 }}</td>
              <td>{{ user?.['total_installs'] || 0 }}</td>
              <td>{{ user?.['cancels'] || 0 }}</td>
              <td>{{ user?.['pending'] || 0 }}</td>
              <td><span class="completion-badge">{{ calculatePullThrough(user) | percent }}</span></td>
              <td><span class="multiplier-badge">{{ getUserMultiplier(user) | number:'1.1-2' }}x</span></td>
              <td><strong class="score-value">{{ getUserScore(user) | number:'1.0-1' }}</strong></td>
            </tr>
          </tbody>
        </nz-table>
      </div>

      <!-- Mobile Card View -->
      <div class="mobile-leaderboard" *ngIf="isMobile">
        <div *ngFor="let user of getSortedLeaderboardData(); let i = index" 
             class="player-card"
             [ngClass]="{
               'rank-1': i === 0,
               'rank-2': i === 1,
               'rank-3': i === 2,
               'expanded': isCardExpanded(i)
             }"
             (click)="toggleCard(i)">
          <div class="player-card-header">
            <div class="player-rank">
              <span [ngSwitch]="i">
                <span *ngSwitchCase="0" class="medal">🥇</span>
                <span *ngSwitchCase="1" class="medal">🥈</span>
                <span *ngSwitchCase="2" class="medal">🥉</span>
                <span *ngSwitchDefault class="rank-num">#{{ i + 1 }}</span>
              </span>
            </div>
            <div class="player-info">
              <div class="player-name">{{ user['first_name'] }} {{ user['last_name'] }}</div>
              <div class="player-metric-highlight">
                <span class="metric-label-mini">{{ getLeaderboardMetricLabel() }}:</span>
                <span class="metric-value-highlight">{{ formatMetricValue(getLeaderboardMetricValue(user), leaderboardSortBy) }}</span>
              </div>
            </div>
            <div class="expand-icon">
              <span *ngIf="!isCardExpanded(i)">▼</span>
              <span *ngIf="isCardExpanded(i)">▲</span>
            </div>
          </div>
          <div class="player-stats" *ngIf="isCardExpanded(i)" [@slideDown]>
            <div class="player-stat">
              <div class="stat-icon-small">📊</div>
              <div class="stat-details">
                <div class="stat-num">{{ user?.['total_orders'] || 0 }}</div>
                <div class="stat-label-small">Sales</div>
              </div>
            </div>
            <div class="player-stat">
              <div class="stat-icon-small">✅</div>
              <div class="stat-details">
                <div class="stat-num">{{ user?.['total_installs'] || 0 }}</div>
                <div class="stat-label-small">Installs</div>
              </div>
            </div>
            <div class="player-stat">
              <div class="stat-icon-small">❌</div>
              <div class="stat-details">
                <div class="stat-num">{{ user?.['cancels'] || 0 }}</div>
                <div class="stat-label-small">Cancels</div>
              </div>
            </div>
            <div class="player-stat">
              <div class="stat-icon-small">⏳</div>
              <div class="stat-details">
                <div class="stat-num">{{ user?.['pending'] || 0 }}</div>
                <div class="stat-label-small">Pending</div>
              </div>
            </div>
            <div class="player-stat">
              <div class="stat-icon-small">🎯</div>
              <div class="stat-details">
                <div class="stat-num">{{ calculatePullThrough(user) | percent }}</div>
                <div class="stat-label-small">Completion</div>
              </div>
            </div>
            <div class="player-stat">
              <div class="stat-icon-small">✨</div>
              <div class="stat-details">
                <div class="stat-num">{{ getUserMultiplier(user) | number:'1.1-2' }}x</div>
                <div class="stat-label-small">Multiplier</div>
              </div>
            </div>
            <div class="player-stat">
              <div class="stat-icon-small">💯</div>
              <div class="stat-details">
                <div class="stat-num">{{ getUserScore(user) | number:'1.0-1' }}</div>
                <div class="stat-label-small">Score</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nz-skeleton>
  </div>

</div>